import React, { Component, Fragment, useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '@material-ui/core/Input';
import MaskInput from './MaskInput';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import IconButton from '@material-ui/core/IconButton';

import FormGroup from '@material-ui/core/FormGroup';
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import FormLabel from '@material-ui/core/FormLabel';
import Slider from '@material-ui/core/Slider';

import Chip from '@material-ui/core/Chip';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';


import './FormsInput.css'


const FormsInput = (props) => {
    const [values, setValues] = useState({
        showPassword: false,
    });
    const [checked, setChecked] = React.useState(true);

    // const [profileState, setProfileState] = useState(props);
    let inputElement = null;
    let inputInvalidMsg = ''
    let maxLength = null;
    let error = false;
    // useEffect(() => {
    //     setProfileState(props);
    //   }, [props]);
    // if (props.invalid && props.shouldValidiate) {
    //     inputInvalid = "Invalid";
    //     //invalidDisplay = (Error)
    // }
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    switch (props.elementType) {

        case ('input'):
            inputElement = <TextField
                //error={ErrorTxt}
                {...props.elementConfig}
                variant={props.variant}
                label={props.label}
                value={props.value}
              
                helperText={props.helperText}
                // helperText={inputInvalid}
                InputLabelProps={{
                    style: { color: props.color }
                }}
                name={props.name}
                type={props.type}
                className={props.classname}
                onChange={props.changed}
            />
            break;
        case ('password'):
                inputElement = <FormControl error={error} className= {"txtwidth " + props.classname} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password" required className="txtwidth">{props.label}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={values.showPassword ? 'text' : 'password'}
                        value={props.value}
                        name={props.name}
                        className={"txtwidth"}
                        onChange={props.changed}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText id="component-helper-text">{inputInvalidMsg}</FormHelperText>
    
                </FormControl>
                break;

        case ('weight'):
            inputElement = <TextField
              
                //error={ErrorTxt}
                {...props.elementConfig}
                variant={props.variant}
                label={props.label}
                value={props.value}
                InputLabelProps={{
                    style: { color: props.color }
                }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">Kg</InputAdornment>,
                }}
                name={props.name}
                type={props.type}
                className="fullinputwidth "
                onChange={props.changed}
            />
            break;

        case ('size'):
            inputElement = <FormControl variant={props.variant} size="small" className={"txtwidth border-custom-input"}>
                <InputLabel size="small" variant={props.variant}>{props.label}</InputLabel>
                <Input
                    variant={props.variant}
                    value={props.value}
                    onChange={props.changed}
                    name={props.name}
                    className="size-center"
                    id="formatted-text-mask-input"
                    inputComponent={MaskInput}
                />
                <FormHelperText>Length X Width X Height</FormHelperText>
            </FormControl>
            break;

        case ('select'):
            inputElement = <FormControl variant={props.variant} size="small" className={"txtwidth " + props.classname} {...props.error}>
                <InputLabel >{props.label}</InputLabel>
                <Select
                  
                    labelId={props.label}
                    className={"fullinputwidth " + props.classname}
                    value={props.value }
                    name={props.name}
                    label={props.label}
                    defaultValue={[props.elementConfig.options[0]]}
                    onChange={props.changed}
                    onClick={props.clicked}
                >
                    {props.elementConfig.options.map((option, index) => (
                        <MenuItem key={index} value={option.value}>{option.displayValue}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            break;

        case ('multiselect'):
            inputElement = <Autocomplete
                multiple
                id="tags-standard"
                options={props.elementConfig.options}
                getOptionLabel={(option) => option.displayValue}
                defaultValue={[props.elementConfig.options[0]]}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip key={index} color="primary" label={option.displayValue} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={props.label}
                        variant={props.variant}
                        className="fullinputwidth "
                        placeholder={props.placeholder}
                    />
                )}
            />
            break;

        case ('multiline'):
            inputElement = <TextField
              
                //error={ErrorTxt}
                {...props.elementConfig}
                variant={props.variant}
                label={props.label}
                value={props.value}
                rows={7}
                // rowsMax={10}
                multiline
                // helperText={inputInvalid}
                InputLabelProps={{
                    style: { color: props.color }
                }}
                name={props.name}
                type="text"
                className={props.classname}
                onChange={props.changed}
            />
            break;

        case ('autocomplete'):
                inputElement = 
                <Autocomplete
                    freeSolo
                    onChange={props.changed}
                    options={props.elementConfig.options}
                    getOptionSelected={(option, value) => option.name == option.value}
                    getOptionLabel={(option) => option.name ? option.name : ''}
                    defaultValue={props.elementConfig.options[0]}
                    renderInput={(params) => (
                        <TextField 
                        onChange={props.changed}
                        helperText={inputInvalidMsg}
                        // error={error}
                        {...params} 
                        label={props.label} 
                        required={props.elementConfig.required}
                        margin="normal" 
                        variant="outlined"  
                       
                        />
                    )}
                />
                break;
        case ('datepicker'):
            inputElement = <TextField
              
                variant={props.variant}
                name={props.name}
                label={props.label}
                type="date"
                value={props.value}
                onChange={props.changed}
                className="fullinputwidth "
                InputLabelProps={{
                    shrink: true,
                }}
            />
            break;
        case ('checkBox'):
            inputElement =
                <Fragment>
                    <FormControlLabel
                        control={<Checkbox
                            checked={props.value}
                            onChange={props.changed}
                            name={props.name}
                            value={props.name}
                            style={{
                                color: "#3f51b5",
                            }}
                        />}
                        label={props.label}
                    />

                </Fragment>
            break;

        case ('radio'):
            inputElement = <FormControl component="fieldset">
                <FormLabel component="legend">{props.label}</FormLabel>
                <RadioGroup aria-label="gender" name="gender1" value={props.value} onChange={props.changed} row={true}>
                    {props.elementConfig.options.map((d, i) => (
                        <FormControlLabel value={d.value} control={<Radio />} label={d.displayValue} />

                    ))}
                </RadioGroup>
            </FormControl>
            break;
        case ('checkboxGroup'):
            inputElement =  <FormControl component="fieldset" className={''}>
            <FormLabel component="legend">{props.label}</FormLabel>
            <hr />
            <FormGroup>
                {props.elementConfig.options.map((d, i) => (
                    <FormControlLabel
                        key={i}
                        value={d.value}
                        control={<Checkbox checked={d.value} onChange={props.changed} name={d.name} />}
                        label={d.name}
                    />

                ))
                }
            </FormGroup>
        </FormControl>

            break;
        case ('buttongroup'):
            inputElement =  <ButtonGroup size="small" aria-label="small outlined button group">
            <Button onClick={props.changed}>+</Button>
            <Button >{props.value}</Button>
            {props.value && <Button onClick={props.decrement}>-</Button>}
          </ButtonGroup>
            break;
        case ('slider'):
            inputElement = <Slider
                value={props.value}
                onChange={props.changed}
                step={10}
                defaultValue={props.max}
                min={props.min}
                max={props.max}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
                // getAriaValueText={props.value}
                marks={props.elementConfig.options}
                
            />

            break;
        default:

    }

    return (
        <Fragment>
            {inputElement}

        </Fragment>

    );



}

export default FormsInput;